import { Component, OnInit, inject, ChangeDetectionStrategy, computed } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { NotificationLayout, NotificationTheme } from '@fcom/ui-components';

import { GtmService } from '../../gtm';
import { GtmEvent } from '../../interfaces';
import { FinnairThemeService } from '../../services/theme/finnair-theme.service';
import { FinnairTheme } from '../../interfaces/theme.interface';

@Component({
  selector: 'fin-newsletter-notification',
  templateUrl: './newsletter-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NewsletterNotificationComponent implements OnInit {
  private router = inject(Router);
  private gtmService = inject(GtmService);
  private themeService = inject(FinnairThemeService);

  readonly NotificationTheme = NotificationTheme;
  readonly NotificationLayout = NotificationLayout;

  readonly isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  showNotification = false;

  ngOnInit(): void {
    const route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;

    if (route.queryParamMap.has('newsletterSubscribed')) {
      this.gtmService.pushEventToDataLayer(GtmEvent.NEWSLETTER_SUBSCRIPTION_COMPLETED);
      this.showNotification = true;
      this.router.navigate([], {
        replaceUrl: true,
        state: { skipFilterSet: true },
      });
    }
  }
}
